module.exports = __webpack_public_path__ + "images/3c8c7076a03bf0ad43271dfd21978d600f1f3ca139da00e6dc195bd51012d3be.svg";